import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useGroupLocationList } from "../../../hooks";

const GroupCodeSelect = props => {
  const { setValue, defaultSelectAll } = props;
  const { t } = useTranslation(["order"]);
  const { data: groupCode, refetch: refetchGroupCode } = useGroupLocationList(
    {}
  );

  useEffect(() => {
    refetchGroupCode();
  }, []);

  useEffect(() => {
    if (groupCode && defaultSelectAll) {
      setTimeout(() => {
        setValue("group_code", groupCode);
      });
    }
  }, [groupCode, defaultSelectAll]);

  return (
    <Select
      isMulti
      {...props}
      placeholder={t("placeholder.select", {
        title: t("form.group_code"),
      })}
      options={[
        {
          value: "All",
          label: "Tất cả",
        },
        ...groupCode,
      ]}
      classNamePrefix="select2-selection"
      onChange={listSelect => {
        if (listSelect && listSelect?.find(item => item?.value === "All")) {
          setValue("group_code", groupCode);
        } else {
          setValue("group_code", listSelect);
        }
      }}
    />
  );
};

export default GroupCodeSelect;
